var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialogBox" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "login-dialog",
          attrs: {
            "show-close": false,
            title: _vm.isloginpage ? "欢迎登录" : "欢迎注册",
            visible: _vm.dialogVisible,
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeLogin,
          },
        },
        [
          _vm.isloginpage
            ? _c("div", { staticClass: "login-content" }, [
                _c("i", {
                  staticClass: "el-icon-close login-close",
                  on: { click: _vm.closeLogin },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "loginInfo" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userName,
                        expression: "userName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "请输入您的账号",
                      maxlength: "20",
                      required: "",
                    },
                    domProps: { value: _vm.userName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.userName = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      placeholder: "请输入您的密码",
                      maxlength: "20",
                      required: "",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.goLogin.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "defaultReminder" }, [
                    _vm._v("*默认密码为手机号后四位"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn-login", on: { click: _vm.goLogin } },
                    [_vm._v("立即登录")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "login-default-div" }, [
                  _c(
                    "span",
                    {
                      staticClass: "login-default",
                      on: { click: _vm.goRetrievePasswords },
                    },
                    [_vm._v("忘记密码")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "login-default",
                      on: {
                        click: function ($event) {
                          _vm.isloginpage = false
                        },
                      },
                    },
                    [_vm._v("注册账号")]
                  ),
                ]),
              ])
            : _c(
                "div",
                { staticClass: "login-content" },
                [
                  _c("i", {
                    staticClass: "el-icon-close login-close",
                    on: { click: _vm.closeLogin },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "registration",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.userObj,
                        "status-icon": "",
                        rules: _vm.rules,
                        size: "medium ",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号", prop: "username" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入账号" },
                            model: {
                              value: _vm.userObj.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.userObj, "username", _vm._n($$v))
                              },
                              expression: "userObj.username",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "password" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              placeholder: "请输入密码",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.userObj.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.userObj, "password", $$v)
                              },
                              expression: "userObj.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "确认密码", prop: "checkPassword" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              placeholder: "请再次输入密码",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.userObj.checkPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.userObj, "checkPassword", $$v)
                              },
                              expression: "userObj.checkPassword",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入姓名" },
                            model: {
                              value: _vm.userObj.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.userObj, "name", _vm._n($$v))
                              },
                              expression: "userObj.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "phone" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入手机号" },
                              model: {
                                value: _vm.userObj.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userObj, "phone", _vm._n($$v))
                                },
                                expression: "userObj.phone",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    disabled: _vm.phoneCodeDisabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getPhoneCode("registration")
                                    },
                                  },
                                  slot: "append",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.count
                                        ? _vm.count + "s 后重发"
                                        : "获取验证码"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码", prop: "phoneCode" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入验证码" },
                            model: {
                              value: _vm.userObj.phoneCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.userObj, "phoneCode", _vm._n($$v))
                              },
                              expression: "userObj.phoneCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitRegistration("registration")
                                },
                              },
                            },
                            [_vm._v("提交")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("registration")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-default-div" }, [
                    _c(
                      "span",
                      {
                        staticClass: "login-default",
                        on: { click: _vm.goRetrievePasswords },
                      },
                      [_vm._v("忘记密码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "login-default",
                        on: {
                          click: function ($event) {
                            _vm.isloginpage = true
                          },
                        },
                      },
                      [_vm._v("返回登录")]
                    ),
                  ]),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.changeDialogVisible,
            width: "25%",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeDialogVisible = $event
            },
            close: _vm.changeClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                "status-icon": "",
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "oldPassword" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    model: {
                      value: _vm.ruleForm.oldPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "oldPassword", $$v)
                      },
                      expression: "ruleForm.oldPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "newPassword" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    model: {
                      value: _vm.ruleForm.newPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "newPassword", $$v)
                      },
                      expression: "ruleForm.newPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "checkNewPassword" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", autocomplete: "off" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submitForm("ruleForm")
                      },
                    },
                    model: {
                      value: _vm.ruleForm.checkNewPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "checkNewPassword", $$v)
                      },
                      expression: "ruleForm.checkNewPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确认修改")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "login-dialog",
          attrs: {
            "show-close": true,
            title: "选择用户",
            visible: _vm.usersDialogVisible,
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.usersDialogVisible = $event
            },
            close: _vm.closeSelectDialog,
          },
        },
        [
          _c(
            "div",
            { staticClass: "userListBox" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.userType,
                    callback: function ($$v) {
                      _vm.userType = $$v
                    },
                    expression: "userType",
                  },
                },
                [
                  _vm.reviewers.length > 0
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "评审", name: "评审" },
                        },
                        [
                          _c(
                            "el-row",
                            _vm._l(_vm.reviewers, function (item, index) {
                              return _c(
                                "el-col",
                                {
                                  key: index,
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                    padding: "5px",
                                  },
                                  attrs: {
                                    span:
                                      24 /
                                      (_vm.reviewers.length > 4
                                        ? 4
                                        : _vm.reviewers.length % 4),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectUser(item, "评审")
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "avatarBox" }, [
                                        _c("img", {
                                          attrs: { src: item.avatar, alt: "" },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "avatarName" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.currentSchool
                                              ? item.currentSchool.name
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.users.length > 0
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "教师", name: "教师" },
                        },
                        [
                          _c(
                            "el-row",
                            _vm._l(_vm.users, function (item, index) {
                              return _c(
                                "el-col",
                                {
                                  key: index,
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                    padding: "5px",
                                  },
                                  attrs: {
                                    span:
                                      24 /
                                      (_vm.users.length > 4
                                        ? 4
                                        : _vm.users.length % 4),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectUser(item, "教师")
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "avatarBox" }, [
                                        _c("img", {
                                          attrs: { src: item.avatar, alt: "" },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "avatarName" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.currentSchool
                                              ? item.currentSchool.name
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.students.length > 0
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "学生", name: "学生" },
                        },
                        [
                          _c(
                            "el-row",
                            _vm._l(_vm.students, function (item, index) {
                              return _c(
                                "el-col",
                                {
                                  key: index,
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                    padding: "5px",
                                  },
                                  attrs: {
                                    span:
                                      24 /
                                      (_vm.students.length > 4
                                        ? 4
                                        : _vm.students.length % 4),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectUser(item, "学生")
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "avatarBox" }, [
                                        _c("img", {
                                          attrs: { src: item.avatar, alt: "" },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "avatarName" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.currentSchool
                                              ? item.currentSchool.name
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.communityUsers.length > 0
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "注册用户", name: "注册用户" },
                        },
                        [
                          _c(
                            "el-row",
                            _vm._l(_vm.communityUsers, function (item, index) {
                              return _c(
                                "el-col",
                                {
                                  key: index,
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                    padding: "5px",
                                  },
                                  attrs: {
                                    span:
                                      24 /
                                      (_vm.communityUsers.length > 4
                                        ? 4
                                        : _vm.communityUsers.length % 4),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectUser(
                                            item,
                                            "注册用户"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "avatarBox" }, [
                                        _c("img", {
                                          attrs: { src: item.avatar, alt: "" },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "avatarName" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.currentSchool
                                              ? item.currentSchool.name
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "login-dialog",
          attrs: {
            "show-close": false,
            title: "找回密码",
            visible: _vm.retrievePasswordsDialogVisible,
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.retrievePasswordsDialogVisible = $event
            },
            close: _vm.closeRetrievePasswords,
          },
        },
        [
          _c("i", {
            staticClass: "el-icon-close login-close",
            on: { click: _vm.closeRetrievePasswords },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "changePasswordBox" },
            [
              _c(
                "el-form",
                {
                  ref: "retrievePasswordRuleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.retrievePassword,
                    "status-icon": "",
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入手机号" },
                          model: {
                            value: _vm.retrievePassword.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.retrievePassword,
                                "phone",
                                _vm._n($$v)
                              )
                            },
                            expression: "retrievePassword.phone",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "append",
                                disabled: _vm.phoneCodeDisabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getPhoneCode(
                                    "retrievePasswordRuleForm"
                                  )
                                },
                              },
                              slot: "append",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.count
                                    ? _vm.count + "s 后重发"
                                    : "获取验证码"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "phoneCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入验证码" },
                        model: {
                          value: _vm.retrievePassword.phoneCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.retrievePassword,
                              "phoneCode",
                              _vm._n($$v)
                            )
                          },
                          expression: "retrievePassword.phoneCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "密码", prop: "pass" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          autocomplete: "off",
                          placeholder: "请输入密码",
                        },
                        model: {
                          value: _vm.retrievePassword.pass,
                          callback: function ($$v) {
                            _vm.$set(_vm.retrievePassword, "pass", $$v)
                          },
                          expression: "retrievePassword.pass",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码", prop: "checkPass" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          autocomplete: "off",
                          placeholder: "请再次输入密码",
                        },
                        model: {
                          value: _vm.retrievePassword.checkPass,
                          callback: function ($$v) {
                            _vm.$set(_vm.retrievePassword, "checkPass", $$v)
                          },
                          expression: "retrievePassword.checkPass",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitRevisePassword(
                                "retrievePasswordRuleForm"
                              )
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("retrievePasswordRuleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "login-default-div" }, [
                _c(
                  "span",
                  {
                    staticClass: "login-default",
                    on: {
                      click: function ($event) {
                        return _vm.goRegister("注册")
                      },
                    },
                  },
                  [_vm._v("立即注册")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "login-default",
                    on: {
                      click: function ($event) {
                        return _vm.goRegister("登录")
                      },
                    },
                  },
                  [_vm._v("返回登录")]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("LessonDialog", { ref: "lessonDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loginDialog.vue?vue&type=template&id=4284fbb1&
// module id = null
// module chunks = 